/** URL search params of the tracker: filters live in the URL so navigation to the editor and back keeps them. */
export interface TaskSearch {
  view?: 'ongoing' | 'done' | 'overdue' | 'all';
  q?: string;
  assignees?: string;
  mine?: '1';
  pillar?: string;
  urgency?: string;
  follow_up?: string;
  topic?: string;
  sort?: string;
  page?: number;
  grouped?: '1';
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export function parseTaskSearch(raw: Record<string, unknown>): TaskSearch {
  const view = str(raw.view);
  const page = Number(raw.page);
  return {
    view: view === 'done' || view === 'overdue' || view === 'all' ? view : view === 'ongoing' ? 'ongoing' : undefined,
    q: str(raw.q),
    assignees: str(raw.assignees),
    mine: raw.mine === '1' || raw.mine === 1 || raw.mine === true ? '1' : undefined,
    pillar: str(raw.pillar),
    urgency: str(raw.urgency),
    follow_up: str(raw.follow_up),
    topic: str(raw.topic),
    sort: str(raw.sort),
    page: Number.isInteger(page) && page > 1 ? page : undefined,
    grouped: raw.grouped === '1' || raw.grouped === 1 || raw.grouped === true ? '1' : undefined,
  };
}
